import { InfoBarIcon } from './InfoBarIcon';

export const InfoBar = ({ content }: { content: string }) => {
  return (
    <div className="info">
      <InfoBarIcon />
      <p className="vp-caption">{content}</p>
    </div>
  );
};
